var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.025)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 40,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAllBMVEUAAAD/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDQe0zvnAAAAMXRSTlMA8r5pgfrl2XxvORbo1czHuaNz7d60sZ6RTkAuHgf04tJ3Yl9EMiwoDJdZU1BILw+GD6la/gAAAWlJREFUOMudlOeWgjAQRic0KVJVin3tZdWd93+5jUsCSYSsx/uHfOSeIQwJ8CF3s4hXhKyi1NtrNDNGgchb9GhjVHC8Dm1uYAfxUfV2BDuxr7L3jb1sRW+KGqrWC2zU0a4zRi0D7m3wH76YOMIXhmmZIKWeshdSwXHbyfQEAIc4vY7Ekms2+wMJGxnAyNb1a66e4YiMDKCsR3fmPQ4TNufT5HHxTIP/VxQYC+6hS1OBnAAoMzc3Tky8IWdCU8TD+BzwSuxaSa10mjUGAchkbbtoIk1FUMkbkYgilqq4lEQHGwr5nGxQenQkfNO5JDryvkjbaEiehS0JazgnNP32cKCA9ewwipjdm34KlEE9XhpJnjWLNOVdJ96ziwNwbgZKWHK7bMOq/L1/KUNUODWP0WMBI9R7DnDmenEGDZXOu4DAtt/z3vz5bEFhFnVpAx9ecUeqRizo5OGGUjUrgF6mbr52CBmGE3cHn/EL7OaoOFzHR+MAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTwitterIcon);
export default __webpack_public_path__ + "static/media/footer-twitter-icon.9b2cb951a7fa58356f8beb87b1250564.svg";
export { ForwardRef as ReactComponent };